import { useLayoutEffect, useRef } from 'react';

// TODO: Fix what the ref value should be
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
const useFocusOn = (ref: any, enabled = true): void => {
    const previousFocusedItem = useRef(document.activeElement as HTMLElement || document.body);

    useLayoutEffect(() => {
        if (enabled === false) {
            return () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
        }

        ref.current?.focus();

        return () => {
            previousFocusedItem.current.focus();
        };
    }, []);
};

export default useFocusOn;
